
import { Button } from "@/components/ui/button";
import { Download, FileText, ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

interface LessonMaterial {
  id: string;
  title: string;
  url: string;
  type: string;
}

interface LessonMaterialsListProps {
  materials: LessonMaterial[];
}

const LessonMaterialsList = ({ materials }: LessonMaterialsListProps) => {
  const [expandedPdfId, setExpandedPdfId] = useState<string | null>(null);
  const [pdfLoading, setPdfLoading] = useState<boolean>(false);

  if (!materials || materials.length === 0) {
    return null;
  }

  const togglePdfExpand = (id: string) => {
    if (expandedPdfId === id) {
      setExpandedPdfId(null);
    } else {
      setExpandedPdfId(id);
      setPdfLoading(true);
    }
  };

  const handlePdfLoad = () => {
    setPdfLoading(false);
  };

  return (
    <div className="mb-8">
      <h2 className="text-xl font-medium mb-3">Materjalid</h2>
      <div className="space-y-4">
        {materials.map(material => (
          <div key={material.id} className="border rounded-md">
            <div 
              className="flex items-center justify-between p-3 hover:bg-gray-50 cursor-pointer"
              onClick={() => togglePdfExpand(material.id)}
            >
              <div className="flex items-center">
                {material.type === 'pdf' ? (
                  <FileText className="h-5 w-5 mr-3 text-kaija-accent" />
                ) : (
                  <Download className="h-5 w-5 mr-3 text-kaija-accent" />
                )}
                <span>{material.title}</span>
              </div>
              <div className="flex gap-2 items-center">
                <Button variant="outline" size="sm" asChild onClick={e => e.stopPropagation()}>
                  <a href={material.url} target="_blank" rel="noopener noreferrer">
                    Ava
                  </a>
                </Button>
                <Button variant="outline" size="sm" asChild onClick={e => e.stopPropagation()}>
                  <a href={material.url} target="_blank" rel="noopener noreferrer" download>
                    Lae alla
                  </a>
                </Button>
                {material.type === 'pdf' && (
                  <Button 
                    variant="ghost" 
                    size="sm" 
                    className="p-1 h-8 w-8"
                  >
                    {expandedPdfId === material.id ? (
                      <ChevronUp className="h-5 w-5" />
                    ) : (
                      <ChevronDown className="h-5 w-5" />
                    )}
                  </Button>
                )}
              </div>
            </div>
            
            {/* PDF Viewer (expanded view) */}
            {material.type === 'pdf' && expandedPdfId === material.id && (
              <div className="p-4 border-t">
                <div className="relative">
                  {pdfLoading && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70">
                      <div className="flex flex-col items-center">
                        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-900"></div>
                        <p className="mt-2 text-gray-700">Dokumendi laadimine...</p>
                      </div>
                    </div>
                  )}
                  <iframe 
                    src={material.url} 
                    width="100%" 
                    height="500px" 
                    title={`PDF Viewer - ${material.title}`} 
                    className="border-0"
                    onLoad={handlePdfLoad}
                  ></iframe>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LessonMaterialsList;
